import { extendTheme } from '@chakra-ui/react';
import {
  ASSET_COLOR,
  BG_ALTERNATIVE,
  BG_LAYER,
  BG_PRIMARY,
  BG_SECONDARY,
  TEXT_ALTERNATIVE,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

const theme = {
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  fonts: {
    heading: FONT_FAMILY.heading,
    subHeading: FONT_FAMILY.subHeading,
    body: FONT_FAMILY.body,
    jost: `'Jost', sans-serif;`,
    delafield: `'Mrs Saint Delafield', cursive;`,
  },
  fontSizes: {
    heading: '22px',
    subHeading: '58px',
    body: '16px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    body: 400,
  },
  colors: {
    bgPrimary: BG_PRIMARY,
    bgSecondary: BG_SECONDARY,
    bgAlternative: BG_ALTERNATIVE,
    backgroundAssetColor: BG_LAYER,
    mainAssetColor: ASSET_COLOR,
    mainColorText: TEXT_PRIMARY,
    secondaryColorText: TEXT_SECONDARY,
    alternativeColorText: TEXT_ALTERNATIVE,
  },
};

export default extendTheme(theme);
